// extracted by mini-css-extract-plugin
module.exports = {"card_footer":"CardFooter_card_footer__v8jbx","cards_logo":"CardFooter_cards_logo__8yazz","logo":"CardFooter_logo__XfVaZ"};